import { z } from 'zod';

const MONEY_INPUT_REGEX = /^\d+(?:\.\d{1,2})?$/;
const MONEY_RESPONSE_REGEX = /^\d+\.\d{2}$/;

export const PAGO_MODALIDAD = {
  NORMAL: 'NORMAL',
  ADELANTADO: 'ADELANTADO',
} as const;

export type PagoModalidad = (typeof PAGO_MODALIDAD)[keyof typeof PAGO_MODALIDAD];

export const FIFO_PREVIEW_POLICY = {
  OLDEST_PENDING_INVOICE_FIRST: 'FIFO_OLDEST_PENDING_INVOICE_FIRST',
} as const;

export type FifoPreviewPolicy = (typeof FIFO_PREVIEW_POLICY)[keyof typeof FIFO_PREVIEW_POLICY];

const positiveMoneyInputSchema = z
  .string()
  .regex(MONEY_INPUT_REGEX, 'montoPago must be a valid money value (max 2 decimals)')
  .refine((value) => Number(value) > 0, 'montoPago must be greater than 0');

const responseMoneySchema = z
  .string()
  .regex(MONEY_RESPONSE_REGEX, 'money values must use 2 decimals');

export const PagoFifoPreviewRequestSchema = z.object({
  idCliente: z.coerce.number().int().positive(),
  montoPago: positiveMoneyInputSchema,
  modalidad: z.literal(PAGO_MODALIDAD.NORMAL),
});

export type PagoFifoPreviewRequest = z.infer<typeof PagoFifoPreviewRequestSchema>;

export const PagoFifoPreviewInvoiceSchema = z.object({
  id: z.number().int().positive(),
  fechaInicio: z.string().min(1),
  fechaFin: z.string().min(1),
  gross: responseMoneySchema,
  saldoAntes: responseMoneySchema,
  montoAplicado: responseMoneySchema,
  saldoDespues: responseMoneySchema,
});

export type PagoFifoPreviewInvoice = z.infer<typeof PagoFifoPreviewInvoiceSchema>;

export const PagoFifoPreviewResponseSchema = z.object({
  idCliente: z.number().int().positive(),
  modalidad: z.literal(PAGO_MODALIDAD.NORMAL),
  montoPago: responseMoneySchema,
  totalDeudaAntes: responseMoneySchema,
  totalAplicado: responseMoneySchema,
  creditoGenerado: responseMoneySchema,
  deudaDespues: responseMoneySchema,
  totalFacturasPendientes: z.number().int().nonnegative(),
  politica: z.literal(FIFO_PREVIEW_POLICY.OLDEST_PENDING_INVOICE_FIRST),
  facturas: z.array(PagoFifoPreviewInvoiceSchema),
});

export type PagoFifoPreviewResponse = z.infer<typeof PagoFifoPreviewResponseSchema>;
